var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99995 2.7C9.49701 2.7 9.89995 3.10294 9.89995 3.6V8.1H14.4C14.897 8.1 15.3 8.50294 15.3 9C15.3 9.49705 14.897 9.9 14.4 9.9H9.89995V14.4C9.89995 14.8971 9.49701 15.3 8.99995 15.3C8.5029 15.3 8.09995 14.8971 8.09995 14.4V9.9H3.59995C3.10289 9.9 2.69995 9.49705 2.69995 9C2.69995 8.50294 3.10289 8.1 3.59995 8.1L8.09995 8.1V3.6C8.09995 3.10294 8.5029 2.7 8.99995 2.7Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBid);
export default __webpack_public_path__ + "static/media/add-bid.d3fc1c5786b428ea2863d7f77125d580.svg";
export { ForwardRef as ReactComponent };